<template>
  <InsideContent
    :title="$t('ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BUILDER.TITLE')"
    :description="$t('ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BUILDER.DESCRIPTION')"
    class="campaign-stas-builder"
  >
    <Card>
      <div class="campaign-stats-builder__filters">
        <CampaignStatsHeader @filterChanged="createReport" />
      </div>
      <ElCollapseTransition>
        <AdChart
          v-show="showChart"
          v-loading="isChartLoading"
          :options="chartOptions"
        />
      </ElCollapseTransition>
    </Card>
  </InsideContent>
</template>

<script>
import InsideContent from '@@/common/layout/InsideContent';
import Card from '@@/common/Card';
import AdChart from '@@/advertisement/common/AdChart';
import CampaignStatsHeader from './CampaignStatsHeader';
import campaignId from '@/mixins/advertisement/campaignId';

import { AdInsight } from '@/api/api';
import { requestQueue } from '@/api';

export default {
  name: 'CampaignStatsBuilder',
  components: {
    InsideContent,
    Card,
    AdChart,
    CampaignStatsHeader,
  },
  mixins: [campaignId],
  data() {
    return {
      showChart: false,
      isChartLoading: false,
      chartOptions: {},
    };
  },
  methods: {
    createReport({ range, bids, chart }) {
      // Flushing previous requests
      // TODO: should be removed after adding Qomri
      requestQueue.flush();

      this.isChartLoading = true;
      this.showChart = true;
      return AdInsight.createChart({
        campaignId: this.campaignId,
        bids,
        range,
        statType: chart,
      })
        .then(({ chartData, dates, unit }) => {
          this.chartOptions = {
            xAxis: {
              categories: dates,
            },
            yAxis: {
              title: {
                text: unit,
              },
            },
            series: chartData,
          };

          this.isChartLoading = false;
        })
        .catch(e => {
          if (!e.status) {
            // It has been cancelled
            // So we should not set loading to false
            return;
          }
          // Otherwise set loading to false
          this.isChartLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.campaign-stats-builder {
  &__filters {
    margin-bottom: $global-margin;
  }
}
</style>
